module.exports = __webpack_public_path__ + "img/ic_shoppinglist_footer.d791d40e.svg";